var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCube2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.139,
    height: 80.255,
    viewBox: "0 0 77.139 80.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182522",
    "data-name": "\\uADF8\\uB8F9 182522",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182186",
    "data-name": "\\uADF8\\uB8F9 182186",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182038",
    "data-name": "\\uADF8\\uB8F9 182038",
    transform: "translate(0 37.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182031",
    "data-name": "\\uADF8\\uB8F9 182031",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182029",
    "data-name": "\\uADF8\\uB8F9 182029",
    transform: "translate(0.239 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130584",
    "data-name": "\\uD328\\uC2A4 130584",
    d: "M457.3,622.263l14.021,7.812V613.611L457.3,605.8Z",
    transform: "translate(-457.303 -605.799)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182030",
    "data-name": "\\uADF8\\uB8F9 182030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130585",
    "data-name": "\\uD328\\uC2A4 130585",
    d: "M470.962,629.951a.236.236,0,0,1-.116-.03l-14.021-7.812a.239.239,0,0,1-.123-.208V605.437a.239.239,0,0,1,.355-.209l14.02,7.812a.237.237,0,0,1,.122.208v16.464a.238.238,0,0,1-.118.206A.242.242,0,0,1,470.962,629.951Zm-13.783-8.19,13.545,7.546v-15.92l-13.545-7.546Z",
    transform: "translate(-456.702 -605.198)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182034",
    "data-name": "\\uADF8\\uB8F9 182034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182032",
    "data-name": "\\uADF8\\uB8F9 182032",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130586",
    "data-name": "\\uD328\\uC2A4 130586",
    d: "M457.3,594.961l14.1,7.826,12.8-7.173-14.1-7.826Z",
    transform: "translate(-457.303 -587.787)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182033",
    "data-name": "\\uADF8\\uB8F9 182033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130587",
    "data-name": "\\uD328\\uC2A4 130587",
    d: "M471.044,602.664a.233.233,0,0,1-.116-.03l-14.1-7.826a.238.238,0,0,1,0-.416l12.8-7.174a.24.24,0,0,1,.232,0l14.1,7.826a.238.238,0,0,1,0,.416l-12.8,7.174A.244.244,0,0,1,471.044,602.664ZM457.43,594.6l13.614,7.554,12.311-6.9L469.741,587.7Z",
    transform: "translate(-456.702 -587.187)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182037",
    "data-name": "\\uADF8\\uB8F9 182037",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182035",
    "data-name": "\\uADF8\\uB8F9 182035",
    transform: "translate(0.239 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130588",
    "data-name": "\\uD328\\uC2A4 130588",
    d: "M505.876,624.476l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-493.255 -607.488)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182036",
    "data-name": "\\uADF8\\uB8F9 182036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130589",
    "data-name": "\\uD328\\uC2A4 130589",
    d: "M492.893,631.086a.243.243,0,0,1-.123-.033.24.24,0,0,1-.116-.2v-16.63a.239.239,0,0,1,.122-.208l12.621-7.091a.233.233,0,0,1,.237,0,.236.236,0,0,1,.118.205v16.988a.239.239,0,0,1-.126.21L493,631.058A.243.243,0,0,1,492.893,631.086Zm.238-16.729V630.45l12.145-6.48V607.533Zm12.383,9.757h0Z",
    transform: "translate(-492.654 -606.887)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182058",
    "data-name": "\\uADF8\\uB8F9 182058",
    transform: "translate(4.125 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182051",
    "data-name": "\\uADF8\\uB8F9 182051",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182049",
    "data-name": "\\uADF8\\uB8F9 182049",
    transform: "translate(0.239 0.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130596",
    "data-name": "\\uD328\\uC2A4 130596",
    d: "M467.685,526.76l14.021,7.812V518.107L467.685,510.3Z",
    transform: "translate(-467.685 -510.295)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182050",
    "data-name": "\\uADF8\\uB8F9 182050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130597",
    "data-name": "\\uD328\\uC2A4 130597",
    d: "M481.344,534.45a.236.236,0,0,1-.116-.031l-14.02-7.812a.237.237,0,0,1-.122-.208V509.935a.238.238,0,0,1,.354-.207l14.021,7.812a.236.236,0,0,1,.123.207v16.465a.236.236,0,0,1-.118.2A.232.232,0,0,1,481.344,534.45Zm-13.783-8.19,13.545,7.546V517.887l-13.545-7.546Z",
    transform: "translate(-467.085 -509.697)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182054",
    "data-name": "\\uADF8\\uB8F9 182054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182052",
    "data-name": "\\uADF8\\uB8F9 182052",
    transform: "translate(0.239 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130598",
    "data-name": "\\uD328\\uC2A4 130598",
    d: "M467.685,499.46l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-467.685 -492.286)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182053",
    "data-name": "\\uADF8\\uB8F9 182053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130599",
    "data-name": "\\uD328\\uC2A4 130599",
    d: "M481.426,507.162a.238.238,0,0,1-.116-.03l-14.1-7.826a.239.239,0,0,1,0-.417l12.8-7.174a.239.239,0,0,1,.232,0l14.1,7.826a.239.239,0,0,1,0,.417l-12.8,7.173A.235.235,0,0,1,481.426,507.162ZM467.812,499.1l13.614,7.554,12.311-6.9L480.124,492.2Z",
    transform: "translate(-467.085 -491.685)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182057",
    "data-name": "\\uADF8\\uB8F9 182057",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182055",
    "data-name": "\\uADF8\\uB8F9 182055",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130600",
    "data-name": "\\uD328\\uC2A4 130600",
    d: "M516.257,528.973l-12.622,6.734V519.076l12.622-7.091Z",
    transform: "translate(-503.636 -511.985)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182056",
    "data-name": "\\uADF8\\uB8F9 182056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130601",
    "data-name": "\\uD328\\uC2A4 130601",
    d: "M503.274,535.584a.234.234,0,0,1-.122-.034.238.238,0,0,1-.116-.2V518.715a.237.237,0,0,1,.122-.207l12.621-7.091a.238.238,0,0,1,.356.207v16.988a.236.236,0,0,1-.126.21l-12.621,6.735A.246.246,0,0,1,503.274,535.584Zm.238-16.729v16.093l12.145-6.479V512.031Zm12.383,9.757h0Z",
    transform: "translate(-503.036 -511.385)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182068",
    "data-name": "\\uADF8\\uB8F9 182068",
    transform: "translate(38.96 48.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182061",
    "data-name": "\\uADF8\\uB8F9 182061",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182059",
    "data-name": "\\uADF8\\uB8F9 182059",
    transform: "translate(0.238 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130602",
    "data-name": "\\uD328\\uC2A4 130602",
    d: "M555.373,648.17l14.021,7.812V639.518l-14.021-7.812Z",
    transform: "translate(-555.373 -631.706)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182060",
    "data-name": "\\uADF8\\uB8F9 182060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130603",
    "data-name": "\\uD328\\uC2A4 130603",
    d: "M569.032,655.859a.241.241,0,0,1-.116-.03L554.9,648.017a.24.24,0,0,1-.122-.209V631.344a.238.238,0,0,1,.354-.208l14.021,7.812a.238.238,0,0,1,.122.208V655.62a.24.24,0,0,1-.117.206A.243.243,0,0,1,569.032,655.859Zm-13.782-8.19,13.543,7.546V639.3l-13.543-7.546Z",
    transform: "translate(-554.773 -631.106)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182064",
    "data-name": "\\uADF8\\uB8F9 182064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182062",
    "data-name": "\\uADF8\\uB8F9 182062",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130604",
    "data-name": "\\uD328\\uC2A4 130604",
    d: "M555.373,620.868l14.1,7.826,12.8-7.173-14.1-7.827Z",
    transform: "translate(-555.373 -613.694)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182063",
    "data-name": "\\uADF8\\uB8F9 182063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130605",
    "data-name": "\\uD328\\uC2A4 130605",
    d: "M569.115,628.571a.236.236,0,0,1-.116-.03l-14.1-7.826a.239.239,0,0,1,0-.417l12.8-7.173a.238.238,0,0,1,.232,0l14.1,7.826a.239.239,0,0,1,0,.416l-12.8,7.174A.251.251,0,0,1,569.115,628.571ZM555.5,620.506l13.613,7.554,12.311-6.9-13.614-7.555Z",
    transform: "translate(-554.773 -613.095)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182067",
    "data-name": "\\uADF8\\uB8F9 182067",
    transform: "translate(14.283 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182065",
    "data-name": "\\uADF8\\uB8F9 182065",
    transform: "translate(0.238 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130606",
    "data-name": "\\uD328\\uC2A4 130606",
    d: "M603.946,650.384l-12.621,6.733v-16.63l12.621-7.091Z",
    transform: "translate(-591.325 -633.396)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182066",
    "data-name": "\\uADF8\\uB8F9 182066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130607",
    "data-name": "\\uD328\\uC2A4 130607",
    d: "M590.964,656.993a.231.231,0,0,1-.123-.035.236.236,0,0,1-.115-.2v-16.63a.237.237,0,0,1,.121-.207l12.622-7.092a.235.235,0,0,1,.237,0,.238.238,0,0,1,.118.206v16.988a.24.24,0,0,1-.126.211l-12.622,6.734A.236.236,0,0,1,590.964,656.993Zm.238-16.729v16.093l12.144-6.48V633.44Zm12.383,9.757h0Z",
    transform: "translate(-590.726 -632.795)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182078",
    "data-name": "\\uADF8\\uB8F9 182078",
    transform: "translate(33.73 13.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182071",
    "data-name": "\\uADF8\\uB8F9 182071",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182069",
    "data-name": "\\uADF8\\uB8F9 182069",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130608",
    "data-name": "\\uD328\\uC2A4 130608",
    d: "M542.208,561.037l14.021,7.812V552.384l-14.021-7.812Z",
    transform: "translate(-542.208 -544.572)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182070",
    "data-name": "\\uADF8\\uB8F9 182070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130609",
    "data-name": "\\uD328\\uC2A4 130609",
    d: "M555.867,568.726a.239.239,0,0,1-.116-.03l-14.021-7.812a.239.239,0,0,1-.123-.208V544.211a.237.237,0,0,1,.118-.205.24.24,0,0,1,.236,0l14.021,7.812a.239.239,0,0,1,.122.208v16.465a.239.239,0,0,1-.117.205A.244.244,0,0,1,555.867,568.726Zm-13.782-8.19,13.543,7.546v-15.92l-13.543-7.546Z",
    transform: "translate(-541.608 -543.973)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182074",
    "data-name": "\\uADF8\\uB8F9 182074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182072",
    "data-name": "\\uADF8\\uB8F9 182072",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130610",
    "data-name": "\\uD328\\uC2A4 130610",
    d: "M542.208,533.735l14.1,7.826,12.8-7.173-14.1-7.827Z",
    transform: "translate(-542.208 -526.561)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182073",
    "data-name": "\\uADF8\\uB8F9 182073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130611",
    "data-name": "\\uD328\\uC2A4 130611",
    d: "M555.95,541.438a.229.229,0,0,1-.116-.03l-14.1-7.826a.239.239,0,0,1,0-.417l12.8-7.173a.241.241,0,0,1,.232,0l14.1,7.826a.239.239,0,0,1,0,.416l-12.8,7.174A.245.245,0,0,1,555.95,541.438Zm-13.614-8.065,13.613,7.554,12.311-6.9-13.613-7.555Z",
    transform: "translate(-541.608 -525.962)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182077",
    "data-name": "\\uADF8\\uB8F9 182077",
    transform: "translate(14.283 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182075",
    "data-name": "\\uADF8\\uB8F9 182075",
    transform: "translate(0.238 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130612",
    "data-name": "\\uD328\\uC2A4 130612",
    d: "M590.781,563.25l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-578.16 -546.263)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182076",
    "data-name": "\\uADF8\\uB8F9 182076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130613",
    "data-name": "\\uD328\\uC2A4 130613",
    d: "M577.8,569.86a.242.242,0,0,1-.123-.033.239.239,0,0,1-.115-.2v-16.63a.238.238,0,0,1,.121-.207l12.622-7.091a.236.236,0,0,1,.237,0,.239.239,0,0,1,.118.206v16.988a.241.241,0,0,1-.126.21l-12.622,6.734A.235.235,0,0,1,577.8,569.86Zm.239-16.729v16.094l12.144-6.481V546.307Zm12.382,9.757h0Z",
    transform: "translate(-577.561 -545.662)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182088",
    "data-name": "\\uADF8\\uB8F9 182088",
    transform: "translate(28.565 34.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182081",
    "data-name": "\\uADF8\\uB8F9 182081",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182079",
    "data-name": "\\uADF8\\uB8F9 182079",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130614",
    "data-name": "\\uD328\\uC2A4 130614",
    d: "M529.206,613.045l14.021,7.811V604.392l-14.021-7.812Z",
    transform: "translate(-529.206 -596.58)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182080",
    "data-name": "\\uADF8\\uB8F9 182080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130615",
    "data-name": "\\uD328\\uC2A4 130615",
    d: "M542.866,620.734a.242.242,0,0,1-.116-.03l-14.021-7.812a.239.239,0,0,1-.123-.209V596.22a.238.238,0,0,1,.117-.205.243.243,0,0,1,.237,0l14.021,7.812a.237.237,0,0,1,.123.207V620.5a.239.239,0,0,1-.118.206A.243.243,0,0,1,542.866,620.734Zm-13.783-8.19,13.544,7.546V604.172l-13.544-7.548Z",
    transform: "translate(-528.606 -595.982)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182084",
    "data-name": "\\uADF8\\uB8F9 182084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182082",
    "data-name": "\\uADF8\\uB8F9 182082",
    transform: "translate(0.238 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130616",
    "data-name": "\\uD328\\uC2A4 130616",
    d: "M529.206,585.744l14.1,7.827,12.8-7.174-14.1-7.826Z",
    transform: "translate(-529.206 -578.571)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182083",
    "data-name": "\\uADF8\\uB8F9 182083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130617",
    "data-name": "\\uD328\\uC2A4 130617",
    d: "M542.948,593.447a.243.243,0,0,1-.115-.03l-14.1-7.827a.238.238,0,0,1,0-.416l12.8-7.174a.24.24,0,0,1,.233,0l14.1,7.826a.238.238,0,0,1,0,.416l-12.8,7.174A.237.237,0,0,1,542.948,593.447Zm-13.614-8.066,13.614,7.555,12.311-6.9-13.613-7.554Z",
    transform: "translate(-528.606 -577.97)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182087",
    "data-name": "\\uADF8\\uB8F9 182087",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182085",
    "data-name": "\\uADF8\\uB8F9 182085",
    transform: "translate(0.238 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130618",
    "data-name": "\\uD328\\uC2A4 130618",
    d: "M577.779,615.258l-12.622,6.734v-16.63l12.622-7.091Z",
    transform: "translate(-565.157 -598.271)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182086",
    "data-name": "\\uADF8\\uB8F9 182086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130619",
    "data-name": "\\uD328\\uC2A4 130619",
    d: "M564.8,621.868a.237.237,0,0,1-.238-.238V605a.238.238,0,0,1,.122-.207L577.3,597.7a.238.238,0,0,1,.355.208V614.9a.24.24,0,0,1-.127.211l-12.621,6.734A.237.237,0,0,1,564.8,621.868Zm.238-16.729v16.094l12.145-6.48V598.315Zm12.383,9.757h0Z",
    transform: "translate(-564.558 -597.67)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182098",
    "data-name": "\\uADF8\\uB8F9 182098",
    transform: "translate(18.322 22.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182091",
    "data-name": "\\uADF8\\uB8F9 182091",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182089",
    "data-name": "\\uADF8\\uB8F9 182089",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130620",
    "data-name": "\\uD328\\uC2A4 130620",
    d: "M503.424,583.17l14.021,7.812V574.517l-14.021-7.812Z",
    transform: "translate(-503.424 -566.705)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182090",
    "data-name": "\\uADF8\\uB8F9 182090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130621",
    "data-name": "\\uD328\\uC2A4 130621",
    d: "M517.083,590.859a.229.229,0,0,1-.116-.031l-14.021-7.812a.238.238,0,0,1-.122-.208V566.344a.236.236,0,0,1,.118-.2.239.239,0,0,1,.237,0l14.021,7.812a.237.237,0,0,1,.122.208v16.465a.236.236,0,0,1-.117.205A.231.231,0,0,1,517.083,590.859ZM503.3,582.669l13.544,7.546V574.3L503.3,566.75Z",
    transform: "translate(-502.824 -566.106)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182094",
    "data-name": "\\uADF8\\uB8F9 182094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182092",
    "data-name": "\\uADF8\\uB8F9 182092",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130622",
    "data-name": "\\uD328\\uC2A4 130622",
    d: "M503.424,555.869l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-503.424 -548.695)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182093",
    "data-name": "\\uADF8\\uB8F9 182093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130623",
    "data-name": "\\uD328\\uC2A4 130623",
    d: "M517.166,563.572a.24.24,0,0,1-.116-.029l-14.1-7.826a.239.239,0,0,1,0-.417l12.8-7.173a.238.238,0,0,1,.232,0l14.1,7.826a.24.24,0,0,1,0,.417l-12.8,7.174A.253.253,0,0,1,517.166,563.572Zm-13.615-8.065,13.614,7.554,12.311-6.9-13.614-7.553Z",
    transform: "translate(-502.824 -548.096)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182097",
    "data-name": "\\uADF8\\uB8F9 182097",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182095",
    "data-name": "\\uADF8\\uB8F9 182095",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130624",
    "data-name": "\\uD328\\uC2A4 130624",
    d: "M552,585.382l-12.621,6.734v-16.63L552,568.395Z",
    transform: "translate(-539.376 -568.395)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182096",
    "data-name": "\\uADF8\\uB8F9 182096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130625",
    "data-name": "\\uD328\\uC2A4 130625",
    d: "M539.014,591.993a.232.232,0,0,1-.123-.035.238.238,0,0,1-.115-.2v-16.63a.237.237,0,0,1,.121-.207l12.622-7.092a.238.238,0,0,1,.354.208V585.02a.237.237,0,0,1-.125.21l-12.622,6.735A.236.236,0,0,1,539.014,591.993Zm.238-16.729v16.093l12.144-6.479V568.441Zm12.383,9.756h0Z",
    transform: "translate(-538.776 -567.795)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182108",
    "data-name": "\\uADF8\\uB8F9 182108",
    transform: "translate(49.759 22.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182101",
    "data-name": "\\uADF8\\uB8F9 182101",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182099",
    "data-name": "\\uADF8\\uB8F9 182099",
    transform: "translate(0.239 0.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130626",
    "data-name": "\\uD328\\uC2A4 130626",
    d: "M582.559,583.571l14.021,7.812V574.917l-14.021-7.812Z",
    transform: "translate(-582.559 -567.106)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182100",
    "data-name": "\\uADF8\\uB8F9 182100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130627",
    "data-name": "\\uD328\\uC2A4 130627",
    d: "M596.218,591.26a.23.23,0,0,1-.116-.031l-14.021-7.812a.237.237,0,0,1-.123-.207V566.745a.237.237,0,0,1,.118-.2.24.24,0,0,1,.237,0l14.021,7.812a.238.238,0,0,1,.122.208v16.465a.239.239,0,0,1-.238.238Zm-13.783-8.191,13.545,7.546V574.7l-13.545-7.546Z",
    transform: "translate(-581.958 -566.508)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182104",
    "data-name": "\\uADF8\\uB8F9 182104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182102",
    "data-name": "\\uADF8\\uB8F9 182102",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130628",
    "data-name": "\\uD328\\uC2A4 130628",
    d: "M582.559,556.27l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-582.559 -549.096)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182103",
    "data-name": "\\uADF8\\uB8F9 182103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130629",
    "data-name": "\\uD328\\uC2A4 130629",
    d: "M596.3,563.973a.242.242,0,0,1-.116-.03l-14.1-7.826a.241.241,0,0,1-.123-.209.237.237,0,0,1,.122-.208l12.8-7.174a.24.24,0,0,1,.232,0l14.1,7.826a.239.239,0,0,1,0,.417l-12.8,7.173A.241.241,0,0,1,596.3,563.973Zm-13.615-8.065,13.613,7.554,12.312-6.9L595,549.007Z",
    transform: "translate(-581.958 -548.496)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182107",
    "data-name": "\\uADF8\\uB8F9 182107",
    transform: "translate(14.282 7.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182105",
    "data-name": "\\uADF8\\uB8F9 182105",
    transform: "translate(0.239 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130630",
    "data-name": "\\uD328\\uC2A4 130630",
    d: "M631.131,585.783l-12.621,6.735v-16.63l12.621-7.092Z",
    transform: "translate(-618.511 -568.795)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182106",
    "data-name": "\\uADF8\\uB8F9 182106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130631",
    "data-name": "\\uD328\\uC2A4 130631",
    d: "M618.149,592.393a.239.239,0,0,1-.239-.238v-16.63a.238.238,0,0,1,.122-.208l12.621-7.092a.234.234,0,0,1,.237,0,.238.238,0,0,1,.118.206V585.42a.239.239,0,0,1-.126.211l-12.621,6.734A.24.24,0,0,1,618.149,592.393Zm.238-16.729v16.093l12.144-6.48V568.841Zm12.383,9.756h0Z",
    transform: "translate(-617.91 -568.194)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182118",
    "data-name": "\\uADF8\\uB8F9 182118",
    transform: "translate(34.626 31.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182111",
    "data-name": "\\uADF8\\uB8F9 182111",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182109",
    "data-name": "\\uADF8\\uB8F9 182109",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130632",
    "data-name": "\\uD328\\uC2A4 130632",
    d: "M544.463,606.134l14.021,7.812V597.481l-14.021-7.812Z",
    transform: "translate(-544.463 -589.669)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182110",
    "data-name": "\\uADF8\\uB8F9 182110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130633",
    "data-name": "\\uD328\\uC2A4 130633",
    d: "M558.123,613.823a.237.237,0,0,1-.116-.031l-14.021-7.812a.238.238,0,0,1-.122-.208V589.308a.239.239,0,0,1,.354-.208l14.021,7.812a.237.237,0,0,1,.122.207v16.465a.237.237,0,0,1-.117.205A.233.233,0,0,1,558.123,613.823Zm-13.783-8.191,13.544,7.546V597.26l-13.544-7.547Z",
    transform: "translate(-543.863 -589.07)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182114",
    "data-name": "\\uADF8\\uB8F9 182114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182112",
    "data-name": "\\uADF8\\uB8F9 182112",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130634",
    "data-name": "\\uD328\\uC2A4 130634",
    d: "M544.463,578.833l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-544.463 -571.659)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182113",
    "data-name": "\\uADF8\\uB8F9 182113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130635",
    "data-name": "\\uD328\\uC2A4 130635",
    d: "M558.2,586.536a.231.231,0,0,1-.116-.03l-14.1-7.826a.239.239,0,0,1,0-.417l12.8-7.173a.237.237,0,0,1,.232,0l14.1,7.826a.24.24,0,0,1,0,.417l-12.8,7.174A.247.247,0,0,1,558.2,586.536Zm-13.615-8.065,13.614,7.554,12.311-6.9L556.9,571.571Z",
    transform: "translate(-543.863 -571.06)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182117",
    "data-name": "\\uADF8\\uB8F9 182117",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182115",
    "data-name": "\\uADF8\\uB8F9 182115",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130636",
    "data-name": "\\uD328\\uC2A4 130636",
    d: "M593.036,608.346l-12.621,6.734v-16.63l12.621-7.092Z",
    transform: "translate(-580.415 -591.358)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182116",
    "data-name": "\\uADF8\\uB8F9 182116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130637",
    "data-name": "\\uD328\\uC2A4 130637",
    d: "M580.053,614.957a.233.233,0,0,1-.123-.035.237.237,0,0,1-.116-.2v-16.63a.239.239,0,0,1,.122-.208l12.621-7.092a.238.238,0,0,1,.354.207v16.988a.237.237,0,0,1-.125.211l-12.621,6.735A.238.238,0,0,1,580.053,614.957Zm.238-16.729v16.093l12.144-6.479V591.4Zm12.383,9.756h0Z",
    transform: "translate(-579.815 -590.759)",
    fill: "#111"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCube2);
export default __webpack_public_path__ + "static/media/information_cube2.06dc24e2382dce17f50257d6c4940977.svg";
export { ForwardRef as ReactComponent };